__turbopack_context__.v({
  "className": "bricolage_grotesque_4ee578c7-module__ADiiYq__className",
});
